export enum PcsWizardType {
  CarryForwardWizard = 'CarryForwardWizard',
  ImportPapsWizard = 'ImportPapsWizard'
}
